import { jsx as _jsx } from "react/jsx-runtime";
import { EmptyState, FlexBox } from '@dixa/lib-shared-habla';
export function KnowledgeErrorPlaceholder() {
    return (_jsx(FlexBox, Object.assign({ height: "100%", flex: "1", justifyContent: "center", alignItems: "center" }, { children: _jsx(EmptyState, { size: "large", title: "Something went wrong, please reload and try again", description: "If this issue persists, please contact support." }) })));
}
